export const projects = [
  {
    id: 1,
    title: "Whismur",
    description: "Real-time chat application using Socket.io.",
    tech: ["React", "Node.js", "Express", "Socket.io"],
    image: "/whismur.png",
    liveLink: "https://whismur-chat.vercel.app",
    githubLink: "https://github.com/literallyrounak/whismur",
    featured: true,
  },
  {
    id: 2,
    title: "Filmbase",
    description: "A react movie app using OMDB API.",
    tech: ["React", "OMDB API"],
    image: "/filmbase.png",
    liveLink: "https://literallyrounak.github.io/filmbase",
    githubLink: "https://github.com/literallyrounak/filmbase",
  },
  {
    id: 3,
    title: "Portfolio Website",
    description: "Sophisticated brutalist design experiment with pure CSS + React.",
    tech: ["React", "CSS Variables"],
    image: "/portfolio.png",
    liveLink: "https://literallyrounak.github.io",
    githubLink: "https://github.com/literallyrounak/literallyrounak.github.io",
  },
  {
    id: 4,
    title: "Slowpoke",
    description: "A React app which fetches news from various sources using NewsAPI.",
    tech: ["React", "NewsAPI"],
    image: "/slowpoke.png",
    liveLink: "https://literallyrounak.github.io/slowpoke",
    githubLink: "httpa://github.com/literallyrounak/slowpoke",
  },
  {
    id: 5,
    title: "Espeon",
    description: "A React app which has thousand of leetcode problems company-wise (usually paid in leetcode premium) and allows you to filter them based on difficulty, frequency, and more.",
    tech: ["React", "Pandas", "CSVtoJSON"],
    image: "/espeon.png",
    liveLink: "https://literallyrounak.github.io/espeon",
    githubLink: "httpa://github.com/literallyrounak/espeon",
  },
  {
    id: 6,
    title: "Magikarp",
    description: "A C++ tool which helps users to organize their messy folders by sorting them out.",
    tech: ["C++", "Filesystem Library"],
    image: "/magikarp.png",
    githubLink: "httpa://github.com/literallyrounak/magikarp",
  }
];